var local = 'http://127.0.0.1:5000/api'
var online = 'https://sleepyrat.ai/api'

const config = {
    API_BASE_URL: window.location.origin === 'http://localhost:3000' ? local : online,
    // API_BASE_URL: online,
    // API_BASE_URL: local
};

export default config;